// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19":"bc32526e36f8073d","25":"8ae52bb1af9312ab"}[chunkId] + ".js";
};